/* AM-PRODUCT-BADGES 2026-09-01
   En las vitrinas de la FICHA ("Combine & Get Up to 15% Extra Off" y "You May Also Like")
   la insignia de descuento venia como "-60%"; en las paginas de coleccion se muestra como
   "60% OFF". Este asset iguala el TEXTO (el color y la caja los pone el CSS de theme.liquid).
   Va en un asset externo a proposito: los <script> inline dentro de secciones/custom_liquid
   de este tema no se ejecutan de forma fiable.
   Idempotente y con MutationObserver, porque los swipers de las vitrinas clonan slides
   despues de cargar. */
(function () {
  var RE = /^\s*-?\s*(\d{1,3})\s*%\s*$/;

  function fix() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var badges = main.querySelectorAll('.am-discount-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.getAttribute('data-am-badge') === '1') continue;
      var m = RE.exec(b.textContent || '');
      if (!m) continue;                    // ya esta en formato "N% OFF" o no es un %
      b.textContent = m[1] + '% OFF';
      b.setAttribute('data-am-badge', '1');
    }
  }

  function start() {
    fix();
    var main = document.getElementById('MainContent');
    if (!main) return;
    try {
      new MutationObserver(fix).observe(main, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* AM 2026-09-02: cargador de los assets propios de la FICHA.
   Se engancha aqui porque este script ya se carga en las 43 fichas y es el mas pequeno:
   asi no hay que tocar los custom_liquid duplicados en las 43 plantillas de producto.

   2026-09-13: se vuelve a anadir am-sticky-atc-5.js (barra fija de Add to bag), traida del
   tema "Maren - barra fija add to bag 2026-09-02", que nunca llego a publicarse.

   🔴 El CDN de Shopify cachea el asset por NOMBRE y se salta los query propios (probamos
   ?amv=N y seguia sirviendo la version anterior). Para publicar un cambio hay que crear
   el archivo con el numero siguiente y cambiarlo en esta lista, igual que am-trust-2.js
   o am-collection-view-9.js en este mismo tema. */
(function () {
  var ASSETS = ['am-deal-bar-2.js', 'am-sticky-atc-5.js'];

  var me = document.currentScript;
  if (!me) {
    var todos = document.querySelectorAll('script[src*="am-product-badges"]');
    me = todos[todos.length - 1];
  }
  if (!me || !me.src || me.src.indexOf('am-product-badges') === -1) return;

  ASSETS.forEach(function (nombre) {
    if (document.querySelector('script[src*="' + nombre + '"]')) return;
    var s = document.createElement('script');
    s.src = me.src.replace(/am-product-badges-1\.js.*$/, nombre);
    s.defer = true;
    (document.head || document.documentElement).appendChild(s);
  });
})();